export class CadastroNomeUtils{
  static sanitizarNomeParaBanco(valor: any): string {
    if (valor === null || valor === undefined) return null;

    let texto = String(valor).trim();

    // Remove caracteres de controle (inclui \u0000 que costuma quebrar inserts)
    texto = texto.replace(/[\u0000-\u001F\u007F]/g, ' ');

    // Remove qualquer caractere fora do BMP (U+10000+), que vira UTF-8 de 4 bytes (ex.: emojis),
    // incompatível com colunas MySQL configuradas como "utf8" (3 bytes).
    // Implementação sem regex "u" para não depender de flags/target.
    let resultado = '';
    for (let i = 0; i < texto.length; i++) {
      const c = texto.charCodeAt(i);
      const ehHigh = c >= 0xD800 && c <= 0xDBFF;
      const ehLow = c >= 0xDC00 && c <= 0xDFFF;

      if (ehHigh) {
        const prox = texto.charCodeAt(i + 1);
        const proxEhLow = prox >= 0xDC00 && prox <= 0xDFFF;
        if (proxEhLow) {
          i++; // pula o par surrogate (caractere fora do BMP)
          continue;
        }
        // surrogate isolado: descarta
        continue;
      }

      if (ehLow) {
        // surrogate isolado: descarta
        continue;
      }

      resultado += texto.charAt(i);
    }

    // Normaliza espaços e trim final
    resultado = resultado.replace(/\s+/g, ' ').trim();

    return resultado;
  }
}
